import {
    REGISTER_CART,
    SET_EBONS,
    REQUEST_EBONS_PARTNER,
    RECEIVE_EBONS_PARTNER,
    FAILURE_EBONS_PARTNER,
    REQUEST_LOCK_EBONS,
    RECEIVE_LOCK_EBONS,
    FAILURE_LOCK_EBONS,
    REQUEST_CREATE_ORDER,
    RECEIVE_CREATE_ORDER,
    FAILURE_CREATE_ORDER,
    REQUEST_EBONS_FAQ,
    RECEIVE_EBONS_FAQ,
    FAILURE_EBONS_FAQ,
    REQUEST_PARTNERS_EBON,
    RECEIVE_PARTNERS_EBON,
    FAILURE_PARTNERS_EBON,
    REQUEST_EBONS_ORDER,
    RECEIVE_EBONS_ORDER,
    FAILURE_EBONS_ORDER,
    REQUEST_EBONS_BILL,
    RECEIVE_EBONS_BILL,
    FAILURE_EBONS_BILL,
    RESET_LOCK,
    RESET_ORDER,
    REQUEST_LOG_ERROR,
    RECEIVE_LOG_ERROR,
    FAILURE_LOG_ERROR
} from './constants';
import { HTTP_METHOD_POST, HTTP_METHOD_GET } from '../../constants/httpMethod';

import { CALL_API } from '../../middlewares/api';
import { makeActionCreator } from '../../utils/actionsUtils';

export const registerCart = cart => {
    return {
        type: REGISTER_CART,
        payload: cart
    };
};

export const setEbons = ebons => {
    return {
        type: SET_EBONS,
        payload: ebons
    };
};

export const fetcheBonsByPartnerId = partnerId => {
    return {
        [CALL_API]: {
            endpoint: '/ebon/partner/availability?partnerId=' + partnerId + '&withInactive=' + true,
            types: [REQUEST_EBONS_PARTNER, RECEIVE_EBONS_PARTNER, FAILURE_EBONS_PARTNER]
        }
    };
};

export const fetchEbonPartners = () => {
    return {
        [CALL_API]: {
            endpoint: '/ebon/partner',
            types: [REQUEST_PARTNERS_EBON, RECEIVE_PARTNERS_EBON, FAILURE_PARTNERS_EBON]
        }
    };
};

export const fetcheFAQByPartnerId = partnerId => {
    return {
        [CALL_API]: {
            endpoint: '/ebon/faq?partnerId=' + partnerId,
            types: [REQUEST_EBONS_FAQ, RECEIVE_EBONS_FAQ, FAILURE_EBONS_FAQ]
        }
    };
};

export const lockEbons = (email, cart, userId, clickId, score, hash, phoneNumber) => {
    let plebicardUrl = `/public/ebon/lockv2?email=${encodeURIComponent(email)}`;
    plebicardUrl = userId ? plebicardUrl.concat(`&userId=${userId}`) : plebicardUrl;
    plebicardUrl = clickId ? plebicardUrl.concat(`&clickId=${clickId}`) : plebicardUrl;
    plebicardUrl = score ? plebicardUrl.concat(`&score=${score}`) : plebicardUrl;
    plebicardUrl = hash ? plebicardUrl.concat(`&hash=${hash}`) : plebicardUrl;
    plebicardUrl = phoneNumber
        ? plebicardUrl.concat(`&phoneNumber=${encodeURIComponent(phoneNumber)}`)
        : plebicardUrl;

    return {
        [CALL_API]: {
            endpoint: plebicardUrl,
            body: cart,
            types: [REQUEST_LOCK_EBONS, RECEIVE_LOCK_EBONS, FAILURE_LOCK_EBONS],
            method: HTTP_METHOD_POST
        }
    };
};

export const createOrder = (
    email,
    phoneNumber,
    fixedFacialValue,
    partnerId,
    userId,
    clickId,
    sourceId
) => {
    let plebicardUrl = `/public/ebon/order?email=${encodeURIComponent(
        email
    )}&partnerId=${partnerId}`;
    plebicardUrl = userId ? plebicardUrl.concat(`&userId=${userId}`) : plebicardUrl;
    plebicardUrl = clickId ? plebicardUrl.concat(`&clickId=${clickId}`) : plebicardUrl;
    plebicardUrl = sourceId ? plebicardUrl.concat(`&source=${sourceId}`) : plebicardUrl;
    plebicardUrl = phoneNumber
        ? plebicardUrl.concat(`&phoneNumber=${encodeURIComponent(phoneNumber)}`)
        : plebicardUrl;
    plebicardUrl = plebicardUrl.concat(`&fixedFacialValue=${fixedFacialValue}`);

    return {
        [CALL_API]: {
            endpoint: plebicardUrl,
            types: [REQUEST_CREATE_ORDER, RECEIVE_CREATE_ORDER, FAILURE_CREATE_ORDER],
            method: HTTP_METHOD_POST,
            payload: { partnerId }
        }
    };
};

export const fetchEbonOrderByIdWithCode = (id, userId) => {
    let plebicardUrl = `/public/ebon/order/${id}`;
    plebicardUrl = userId ? plebicardUrl.concat(`?userId=${userId}`) : plebicardUrl;

    const apiParameters = {
        endpoint: plebicardUrl,
        types: [REQUEST_EBONS_ORDER, RECEIVE_EBONS_ORDER, FAILURE_EBONS_ORDER]
    };
    return {
        [CALL_API]: apiParameters
    };
};

export const sendDownloadBillRequest = (email, orderId, formData) => {
    return {
        [CALL_API]: {
            endpoint: `/public/ebon/order/${orderId}/bill?email=${encodeURIComponent(email)}`,
            body: formData,
            types: [REQUEST_EBONS_BILL, RECEIVE_EBONS_BILL, FAILURE_EBONS_BILL],
            method: HTTP_METHOD_POST
        }
    };
};

export const getLogErrorPayment = orderId => {
    return {
        [CALL_API]: {
            endpoint: `/ebon/error/log?orderId=${orderId}`,
            types: [REQUEST_LOG_ERROR, RECEIVE_LOG_ERROR, FAILURE_LOG_ERROR],
            method: HTTP_METHOD_GET
        }
    };
};

export const resetLock = makeActionCreator(RESET_LOCK);

export const resetOrder = makeActionCreator(RESET_ORDER);



// WEBPACK FOOTER //
// ./src/services/ebon/actions.js